import React from 'react'
import DigitalForm from './DigitalForm'

const index = () => {
  return (
    <div>
        <DigitalForm/>
      
    </div>
  )
}

export default index
